<template>
  <section class="content">
    <div class="box-solid">
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]"
        >
          <router-link :to="{ name: 'RegionCreate' }">
            <button class="btn">Add New</button>
          </router-link>
        </div>
        <v-server-table
          ref="regionsTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import {authService} from '../../../services'


export default {
  name: 'Region',
  data() {
    return {
      
      USER_ROLES: USER_ROLES,
      loading: null,
      regionsTable: null,
      columns: ['name', 'regionManagerFirstName', 'totalSite', 'status'],
      options: {
        highlightMatches: true,
        sortable: ['name', 'regionManagerFirstName', 'totalSite', 'status'],
        headings: {
          name: 'Name',
          regionManagerFirstName: 'GA Head',
          totalSite: 'Total Locations',
          status: 'Status',
        },
        templates: {
          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          totalSite(row, query) {
            return query.siteCount;
          },
          regionManagerFirstName(row,query){
            return `${query.regionManagerFirstName} ${query.regionManagerLastName}`
          }
        },
        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if(this.user.roleName == "GA Head"){
            params.regionManager = this.user._id
          }
          if(this.user.roleName == "Journey Manager"){
            params.journeyManager[0] = this.user._id
          }
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$regionsDataRepository.list(params).catch(error => {
            console.error('region.requestFunction-error:', error);
            this.$snotify.error('Get Region', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.regionsTable) {
        return this.regionsTable.count > this.regionsTable.limit ||
          this.regionsTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user
      }),
  },
  mounted : function(){
    console.log("mountedd")
    
  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'RegionDetail',
        params: { _id: data.row._id },
        props: data.row,
      });
    },
    onLoaded() {
      this.regionsTable = this.$refs.regionsTable;
    },
  },
};
</script>
<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.btn{
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
        color: white
}
</style>





// WEBPACK FOOTER //
// Region.vue?5079c5d3